module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/bucket-33dab9dc71aaa74fa4c4ba4d2b79bcef.svg";